import React, { useMemo } from "react";
import "./OTCAddonsModal.css";
import X from "../../../icons/X.svg";
import { useCartContext } from "../../../customHooks/useCart";
import OTCProductRowV2 from "../../OTCProductRow/OTCProductRowV2";
import { translate } from "../../../utils/translator";
import { useShippingPageContext } from "../../../pages/v2/ShippingV2/providers/ShippingPageProvider";
import { OtcPopupTrackingContext, trackOtcPopupClick } from "../../../utils/otcPopupExperiment";

type props = {
  productItems: Array<ProductItem>;
  title: string;
  language: string;
  hideModal: () => void;
  trackingContext?: OtcPopupTrackingContext;
};

const OTCAddonsModalV2: React.FC<props> = ({productItems, title,language ,hideModal, trackingContext}) => {

  const {getCart} = useCartContext();
  const {handleOTCProductDecrement, handleOTCProductIncrement} = useShippingPageContext();
  const cart = getCart();
  const track = (click: Parameters<typeof trackOtcPopupClick>[1]) => { if (trackingContext) trackOtcPopupClick(trackingContext, click); };
  const positionOf = (productItem: ProductItem) => productItems.findIndex((p) => p.id === productItem.id) + 1;
  const asProduct = (productItem: ProductItem) => ({ catalog_id: productItem.catalog_id ?? 0, id: productItem.id, source: "bizdev" as const });

  const selectedOTCAddonsByID = useMemo(() => {
    // 1. Get the OTC products
    const cartOTCProducts = cart.products.filter((productItem) => !productItem.is_prescription_drug);
    
    // 2. Return and build the object
    return cartOTCProducts.reduce((acc, productItem) => {
      acc[productItem.product_item_id] = productItem; 
      return acc;
    }, {} as Record<number, CartProductView>);
  
  }, [cart.products]);


  return (
    <div
      className="otc-addons-modal-container"
      onClick={(event: any) => event.stopPropagation()}
    >
      <img src={X} alt="X" onClick={() => { track({ clickType: "close_popup" }); hideModal(); }} />
      <h1>{title}</h1>

      <div className="otc-addons-modal-product-rows">
        {productItems.map((productItem: ProductItem, index) => {
          return (
            <OTCProductRowV2
              key={"otc-modal-product-row-" + productItem.id! + index}
              productItem={productItem}
              showBin={true}
              decrementButtonOnClick={() => { track({ clickType: "decrease_quantity", product: asProduct(productItem), position: positionOf(productItem) }); handleOTCProductDecrement(productItem); }}
              incrementButtonOnClick={() => { track({ clickType: (selectedOTCAddonsByID[productItem.id]?.quantity ?? 0) > 0 ? "increase_quantity" : "add_to_cart", product: asProduct(productItem), position: positionOf(productItem) }); handleOTCProductIncrement(productItem, trackingContext ? "otc_popup" : undefined); }}
              onInformationToggle={(open) => { if (open) track({ clickType: "more_information", product: asProduct(productItem), position: positionOf(productItem) }); }}
            />
          );
        })}
      </div>

      <button id="otc-addons-modal-submit-button" onClick={() => { track({ clickType: "continue" }); hideModal(); }} className="otc-addons-modal-submit">
          { Object.values(selectedOTCAddonsByID).length ?
            translate(language, "shipping", "OTCAddonsModal/add_to_order")
            :
            translate(language, "shipping", "OTCAddonsModal/close_and_proceed")
          }
      </button>

     
    </div>
  );
};

export default OTCAddonsModalV2;
